export default function Asterisk({ className }: SvgProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 9 9"
      fill="none"
    >
      <path
        d="M1.71571 8.78743C1.28273 8.4786 1.14743 7.86096 1.58041 7.29946C2.09457 6.65374 2.87934 6.14839 4.15121 4.9131C2.68991 4.85695 1.30979 4.77273 0.822695 4.63235C0.0920461 4.43583 -0.124443 3.9024 0.064985 3.31283C0.20029 2.75134 0.876817 2.47059 1.4451 2.72326C2.09457 2.94786 2.82522 3.53743 4.25945 4.43583C3.82647 2.69519 3.50174 1.90909 3.47468 1.06684C3.42056 0.393048 3.93472 0 4.503 0C5.07128 0 5.58545 0.393048 5.53132 1.06684C5.50426 1.90909 5.17953 2.75133 4.74655 4.43583C6.01842 3.64973 7.12793 2.89171 7.53384 2.69519C8.21037 2.38636 8.77865 2.75134 8.94102 3.31283C9.13045 3.93048 8.85984 4.43583 8.18331 4.60427C7.66915 4.74465 6.31609 4.82887 4.88186 4.9131C6.07255 5.92379 7.23617 6.87834 7.45266 7.24331C7.88564 7.88903 7.66915 8.4786 7.20911 8.75935C6.83026 9.01203 6.12667 9.06818 5.74781 8.39438C5.50426 8.00133 5.04422 6.82219 4.503 5.22192C3.93472 6.90641 3.50174 8.11363 3.25819 8.50668C2.87934 9.0401 2.20281 9.1524 1.71571 8.78743Z"
        fill="#D7000F"
      />
    </svg>
  )
}
